<script setup lang="ts">
interface IProps {
  color: string
  height?: number
  opacity?: number
}

const props = withDefaults(defineProps<IProps>(), {
  height: 1,
  opacity: 1
})

const dividerColor = computed(() => props.color)
const dividerHeight = computed(() => `${props.height}px`)
const dividerOpacity = computed(() => `${props.opacity}`)
</script>

<template>
  <hr class="divider">
</template>

<style scoped lang="scss">
.divider {
  color: v-bind(dividerColor);
  height: v-bind(dividerHeight);
  opacity: v-bind(dividerOpacity);
}
</style>